import { styled } from '../styled';
export var Content = styled('div', { name: 'QuantumContent' })(function (_a) {
    var theme = _a.theme;
    return ({
        '& > *': {
            marginTop: '1.5em',
            marginBottom: '1.5em',
        },
        // Page title
        '& > h3': {
            marginTop: '2.5em',
            marginBottom: '1em',
        },
        '& > h3 > code': {
            fontSize: '0.8em',
        },
        // Quickstart
        // **************************************
        // Quickstart title (24px)
        '& > h4': {
            marginTop: '2.5em',
            marginBottom: '0.75em',
            // Code: fix at theme level
            fontWeight: theme.typography.fontWeightSemibold,
        },
        '& > h4 > code': {
            fontSize: '0.8em',
        },
        // Section title (18px)
        '& > h5': {
            marginTop: '2em',
            marginBottom: '0.75em',
            // Code: fix at theme level
            fontWeight: theme.typography.fontWeightSemibold,
        },
        // Section subtitle (16px)
        '& > h6': {
            marginTop: '1.75em',
            marginBottom: '0.75em',
            // Code: fix at theme level
            fontWeight: theme.typography.fontWeightSemibold,
        },
        // Body text (14px)
        '& > p': {
            marginTop: '1em',
            marginBottom: '1em',
            lineHeight: 1.6,
        },
        '& > p > code': {
            fontSize: '0.8em',
        },
        '& strong': {
            fontWeight: theme.typography.fontWeightSemibold,
        },
        // List
        '& > ul,& > ol': {
            paddingLeft: '1.25em !important',
        },
        '& > ul > li,& > ol > li': {
            marginBottom: '.25em',
        },
        '& > ul > li': {
            listStyleType: 'square',
        },
        '& > ol > li': {
            listStyleType: 'decimal',
        },
        '& code': {
            // Code: fix at component level
            paddingTop: '1px',
            color: theme.tokens.color_fg_bold,
        },
        // img
        '& > img, & > ul img, & > ol img': {
            marginTop: '1.5em',
            marginBottom: '1.5em',
        },
        '& img': {
            maxWidth: '100%',
        },
        // leading and end spacing
        '& > *:first-child': {
            marginTop: 0,
        },
        '& > *:last-child': {
            marginBottom: 0,
        },
        // being specifc here for known usecases. We might make this less strict later.
        '& > a, & > p > a': {
            color: theme.tokens.color_fg_selected,
            textDecoration: 'none',
            '&:hover': {
                color: theme.tokens.color_bg_selected_hover,
                textDecoration: 'none',
            },
        },
    });
});
